import { TemplatePage } from './types';

const socialPostsPage: TemplatePage = {
  header: {
    color: '#E8CED1',
    icon: 'images/video-templates/fun-social-post.jpg',
    title: 'Fun Social Posts Templates',
    title_meta: '100+ Free Customizable Fun Social Video Templates',
    description_meta:
      'Amuze your followers with 100+ customizable funny video templates. Create hilarious videos for ' +
      'social media to entertain and engage your audience.',
    description:
      'Give your followers an extra reason to smile. Attract more viewers and subscribers with fun social ' +
      'media videos. Share positive vibes in your feed, grow your audience and keep it engaged.'
  },
  footer: {
    category: 'Fun Social Posts',
    description:
      'You can’t get wrong with Wave.video’s beautiful and fun video templates. Create eye-catching videos for ' +
      'your social media, blog, website, or email newsletter. Pick templates from Wave.video’s collection and ' +
      'customize them in a matter of minutes. All video templates are free and easy to personalize to suit your ' +
      'messaging, occasion, and brand style.'
  },
  content: [
    {
      type: 'templates',
      title: 'Fun Social Posts',
      search: { category: '/Use Cases/Entertainment' }
    },
    {
      type: 'stocks',
      title: 'fun social posts',
      search: { name: 'social posts' }
    },
    { type: 'calendar' }
  ]
};

export default socialPostsPage;
